var exports = {
  "S": "diffHeaderWrapper__EHUZul",
};

module.exports = exports;
